// extracted by mini-css-extract-plugin
export default {"imageWrapper":"image-dnd_imageWrapper__c18G8","description":"image-dnd_description__vf3Gq","dropzone":"image-dnd_dropzone__UjqJ+","dropzoneOver":"image-dnd_dropzoneOver__ozBYf"};